/**
 * Event tracking constants for Workflow Dashboard (new dashboard)
 * Organized by sections: Overview, Prescriptions, Services
 */

const TAB_CLICKED = 'tab_clicked' as const;
const TAB_LOADED = 'tab_loaded' as const;
const FEATURE_CLICKED = 'feature_clicked' as const;
const TAB = 'workflow_dashboard' as const;

/**
 * Workflow Dashboard events
 */
export const WORKFLOW_DASHBOARD_EVENTS = {
  // Organization selector (top-level)
  ORG_SELECTED: {
    action: 'org_selected',
    type: FEATURE_CLICKED,
    tab: TAB,
  },

  // Overview section
  OVERVIEW: {
    TAB_CLICKED: {
      action: TAB_CLICKED,
      type: TAB_CLICKED,
      tab: TAB,
      section: 'overview',
    },
    TAB_LOADED: {
      action: TAB_LOADED,
      type: TAB_LOADED,
      tab: TAB,
      section: 'overview',
    },
  },

  // Prescriptions section
  PRESCRIPTIONS: {
    TAB_CLICKED: {
      action: TAB_CLICKED,
      type: TAB_CLICKED,
      tab: TAB,
      section: 'prescriptions',
    },
    TAB_LOADED: {
      action: TAB_LOADED,
      type: TAB_LOADED,
      tab: TAB,
      section: 'prescriptions',
    },
  },

  // Services section
  SERVICES: {
    TAB_CLICKED: {
      action: TAB_CLICKED,
      type: TAB_CLICKED,
      tab: TAB,
      section: 'services',
    },
    TAB_LOADED: {
      action: TAB_LOADED,
      type: TAB_LOADED,
      tab: TAB,
      section: 'services',
    },
  },

  // Competitor Comparison section
  COMPETITOR_COMPARISON: {
    TAB_CLICKED: {
      action: TAB_CLICKED,
      type: TAB_CLICKED,
      tab: TAB,
      section: 'competitor-comparison',
    },
  },
  TAB_LOADED: {
    action: TAB_LOADED,
    type: TAB_LOADED,
    tab: TAB,
    section: 'competitor-comparison',
  },
};
